/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable react/prop-types */

/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
// Packages
import React, { useState, useEffect, useCallback } from 'react'
import moment from 'moment'
// Helpers

// Styles
import {
	Spin,
	Row,
	Col,
	Form,
	Checkbox,
	Input,
	Select,
	Button,
	Alert,
	DatePicker,
	Switch,
	Menu,
	Dropdown,
	Tooltip,
	Card
} from 'antd'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSortUp, faSortDown, faTimes } from '@fortawesome/free-solid-svg-icons'

import { PlusOutlined, SearchOutlined, DeleteOutlined } from '@ant-design/icons'

import { useNavigate } from 'react-router-dom'

// Components (Controller)
import CreateEditJobController from './CreateEditJobController'

// Components
import SelectWorkingLocation from './WorkingLocation/SelectWorkingLocation'

// Images
import logoEn from '../../public/img/findjobs_en_app_logo.svg'
import logoCn from '../../public/img/findjobs_cn_app_logo.svg'
import logoMy from '../../public/img/findjobs_my_app_logo.svg'

// Job Questions
import ChooseFromTemplate from './JobQuestion/ChooseFromTemplate'

// For antd
const { TextArea } = Input
const { Option } = Select

const employmentType = {
	FT: false,
	PT: false,
	CONTRACT: false
}

const CreateEditJobView = ({ isCreate, state }) => {
	// States
	const [renderReady, setRenderReady] = useState(false)
	const [currentUserCompanies, setCurrentUserCompanies] = useState([])
	const [currentUserBranches, setCurrentUserBranches] = useState([])

	// const [checkboxIndeterminate, setCheckboxIndeterminate] = useState(false)
	// const [checkboxCheckall, setCheckboxCheckall] = useState(false)
	const [selectedCompanies, setSelectedCompanies] = useState([])
	const [isJobType, setIsJobType] = useState({})
	// eslint-disable-next-line
  const [isJobTypeError, setIsJobTypeError] = useState(false)
	// eslint-disable-next-line
  const [checkboxBranchError, setCheckboxBranchError] = useState(false)
	const [isEmploymentType, setIsEmploymentType] = useState(employmentType)
	// eslint-disable-next-line
  const [isEmploymentTypeError, setIsEmploymentTypeError] = useState(false)
	const [jobCategories, setJobCategories] = useState([])
	const [isOtherSelected, setIsOtherSelected] = useState(false)

	// Job specialization
	const [jobSpecialization, setJobSpecialization] = useState([])

	const [workingLocationReady, setWorkingLocationReady] = useState(false)
	const [mrtStationsList, setMrtStationsList] = useState([])
	const [cities, setCities] = useState([])

	// workingLocations stores the JobLocation associated with the Job
	const [branchIds, setBranchIds] = useState([])
	const [workingLocations, setWorkingLocations] = useState([])
	const [cityIds, setCityIds] = useState([])
	//
	const [mrtStationIds, setMRTStationIds] = useState([])

	// JobSalary associaated with the Job
	const [jobSalaries, setJobSalaries] = useState([])

	// eslint-disable-next-line
  const [jobPostEndDate, setJobPostEndDate] = useState()
	const [isJobPostEndDateDisabled, setIsJobPostEndDateDisabled] = useState(false)
	const [selectedCompaniesDetails, setSelectedCompaniesDetails] = useState([])
	const [jobEvents, setJobEvents] = useState([])

	const [hashtags, setHashtags] = useState([])
	const [currentHashtags, setCurrentHashtags] = useState([])

	// Store initialValues
	const [initialValues, setInitialValues] = useState({})

	const handleSelect = (selectedCompaniesDetails) => {
		setSelectedCompaniesDetails(selectedCompaniesDetails)
	}

	// Job Questions
	const [haveQuestion, setHaveQuestion] = useState(false)
	const [jobQuestion, setJobQuestion] = useState([])
	const [searchFromTemplate, setSearchFromTemplate] = useState(false)
	const [currentJobQuestion, setCurrentJobQuestion] = useState([])

	// const [areICMSRequired, setAreICMSRequired] = useState(false)
	const [platform, setPlatform] = useState('')


	const navigate = useNavigate()

	const handleSearchFromTemplate = () => {
		setSearchFromTemplate(!searchFromTemplate)
	}

	const moveUpDown = (upOrDown, index) => {
		const temp = [...jobQuestion]
		if (index > 0 && upOrDown === 'up') {
			const tempVal = temp[index]
			temp[index] = temp[index - 1]
			temp[index - 1] = tempVal
		} else if (index < jobQuestion.length - 1 && upOrDown === 'down') {
			const tempVal = temp[index]
			temp[index] = temp[index + 1]
			temp[index + 1] = tempVal
		}
		setJobQuestion(temp)
	}

	const addNewQuestion = (question) => {
		const temp = [...jobQuestion]
		temp.push(question)
		setJobQuestion(temp)
		// setInitialValues({ ...initialValues, 'question[temp.length]': question.question })
	}

	const addYesNoQuestion = () => {
		const question = {
			isTemplate: false,
			question: '',
			questionChinese: '',
			questionMalay: '',
			questionType: 'YESNO',
			Answers: [{
				answer: 'NO',
				answerChinese: 'NO',
				answerMalay: 'NO',
				sequence: 1
			},
			{
				answer: 'YES',
				answerChinese: 'YES',
				answerMalay: 'YES',
				sequence: 2
			}]
		}
		const temp = [...jobQuestion]
		temp.push(question)
		setJobQuestion(temp)
	}
	const addMultipleChoiceQuestion = () => {
		const question = {
			isTemplate: false,
			question: '',
			questionChinese: '',
			questionMalay: '',
			questionType: 'MCQ',
			Answers: [{
				answer: '',
				answerChinese: '',
				answerMalay: '',
				sequence: 1
			}]
		}
		const temp = [...jobQuestion]
		temp.push(question)
		setJobQuestion(temp)
	}
	const addOpenEndedQuestion = () => {
		const question = {
			isTemplate: false,
			question: '',
			questionChinese: '',
			questionMalay: '',
			questionType: 'OPENENDED',
			Answers: []
		}
		const temp = [...jobQuestion]
		temp.push(question)
		setJobQuestion(temp)
	}

	const deleteQuestion = (i) => {
		const temp = [...jobQuestion]
		temp.splice(i, 1)
		setJobQuestion(temp)
	}

	const removeMcqAns = (q, i) => {
		const temp = [...jobQuestion]
		temp[q].Answers.splice(i, 1)
		setJobQuestion(temp)
	}

	const questionChange = (question, i) => {
		const temp = [...jobQuestion]
		temp[i].question = question.target.value
		setJobQuestion(temp)
	}

	const answerChange = (answer, i, ansIndex) => {
		const temp = [...jobQuestion]
		temp[i].Answers[ansIndex].answer = answer.target.value
		setJobQuestion(temp)
	}

	const maxAnswerChange = (max, i) => {
		const temp = [...jobQuestion]
		temp[i].maxAnswer = max.target.value
		setJobQuestion(temp)
	}

	const addNewAnswer = (i) => {
		const temp = [...jobQuestion]
		const answer = {
			answer: '',
			answerChinese: '',
			answerMalay: '',
			sequence: temp[i].Answers.length + 1
		}
		temp[i].Answers.push(answer)
		setJobQuestion(temp)
	}

	const handleFormSubmit = (values) => {
		if (isCreate) {
			CreateEditJobController.handleOnSubmitCreate(
				values,
				selectedCompaniesDetails,
				currentUserBranches,
				jobEvents,
				jobQuestion,
				haveQuestion,
				// areICMSRequired,
				navigate)
		} else {
			CreateEditJobController.handleOnSubmitUpdate(
				values,
				selectedCompaniesDetails,
				currentUserBranches,
				mrtStationsList,
				cities,
				state.jobId,
				state.companyId,
				jobSalaries,
				isEmploymentType,
				branchIds,
				mrtStationIds,
				cityIds,
				workingLocations,
				currentHashtags,
				jobEvents,
				jobQuestion,
				currentJobQuestion,
				haveQuestion,
				navigate)
		}
	}


	const [form] = Form.useForm()

	const setFormInitialValue = (values) => {
		setInitialValues(values)
	}
	const checkIsCreateAndInitFromController = useCallback(
		async () => {
			if (isCreate) {
				await CreateEditJobController.initCreateJob(
					setCurrentUserCompanies,
					setCurrentUserBranches,
					setMrtStationsList,
					setCities,
					setJobCategories,
					setJobSpecialization,
					setJobPostEndDate,
					setJobEvents,
					setHashtags,
					setRenderReady,
					setInitialValues,
					// setAreICMSRequired,
					setPlatform
				)
				setJobPostEndDate()
				setRenderReady(true)
			} else {
				if (state && state.jobId && state.companyId && state.jobTitle) {
					await CreateEditJobController.initEditJob(
						state.jobId,
						state.companyId,
						setCurrentUserCompanies,
						setIsJobType,
						setBranchIds,
						setMRTStationIds,
						setCityIds,
						setWorkingLocations,
						setCurrentUserBranches,
						setJobSalaries,
						setIsEmploymentType,
						setJobPostEndDate,
						setInitialValues,
						setIsOtherSelected,
						setMrtStationsList,
						setCities,
						setJobCategories,
						setJobSpecialization,
						setJobEvents,
						setHashtags,
						setCurrentHashtags,
						setRenderReady,
						setFormInitialValue,
						setJobQuestion,
						setHaveQuestion,
						setCurrentJobQuestion,
						setPlatform
					)
					setSelectedCompanies([state.companyId]) // Preset Company for Working Location
					setWorkingLocationReady(true)
					setRenderReady(true)
					// console.log(initialValues)
				}
			}
		},
		[isCreate, state]
	)

	useEffect(() => {
		checkIsCreateAndInitFromController()
	}, [checkIsCreateAndInitFromController])

	const handleEmploymentType = (event) => {
		try {
			const setEmploymentType = (event) => {
				const tempEmploymentType = {
					FT: false,
					PT: false,
					CONTRACT: false
				}
				if (event.indexOf('ft') !== -1) {
					tempEmploymentType.FT = true
				}
				if (event.indexOf('pt') !== -1) {
					tempEmploymentType.PT = true
				}
				if (event.indexOf('contract') !== -1) {
					tempEmploymentType.CONTRACT = true
				}
				setIsEmploymentType(tempEmploymentType)
			}
			if (event) {
				setEmploymentType(event)
			}
			// console.log(isEmploymentType)
		} catch (error) {
			console.error(error, 'err-handleEmploymentType')
		}
	}

	// Function for Company Selection Checkbox
	const handleCompanySelectChange = (event) => {
		setSelectedCompanies(event)
		// setCheckboxIndeterminate(!!event.length && event.length < currentUserCompanies.length)
		// setCheckboxCheckall(event.length === currentUserCompanies.length)
		setWorkingLocationReady(event.length !== 0)
	}

	// Function for Company Selection "Checkall" checkbox
	// const handleCompanySelectCheckAllChange = (event) => {
	//   setSelectedCompanies(event.target.checked
	//     ? currentUserCompanies.map(company => company.value)
	//     : [])
	//   setCheckboxIndeterminate(false)
	//   setCheckboxCheckall(event.target.checked)
	//   setWorkingLocationReady(event.target.checked)
	// }

	const handleCategoryVisibility = (e) => {
		if (e === 9999) {
			setIsOtherSelected(true)
		} else {
			setIsOtherSelected(false)
		}
	}

	// Handler for Language Selection
	const handleShouldLanguageUpdate = (prev, curr) => {
		const currentLanguageSelected = curr.jobType || null
		if (currentLanguageSelected && currentLanguageSelected.length) {
			const jobTypeObj = {}
			currentLanguageSelected.forEach((language) => {
				jobTypeObj[language] = true
				return jobTypeObj
			})
			setIsJobType(jobTypeObj)
		} else {
			setIsJobType({})
		}
	}

	const disabledDate = current => {
		const tooEarly = current.isBefore(moment())
		const tooLate = current.isAfter(moment().add(3, 'months'))

		return tooEarly || tooLate
	}

	const handleEventChange = (value) => {
		if (value && jobEvents && jobEvents.length) {
			const selectedEvent = jobEvents.find((event) => event.id === value)
			setIsJobPostEndDateDisabled(true)
			form.setFieldsValue({ jobPostEndDate: selectedEvent.endDate ? moment(selectedEvent.endDate) : null })
		} else {
			setIsJobPostEndDateDisabled(false)
			form.setFieldsValue({ jobPostEndDate: null })
		}
	}


	return (
		<>
			{!renderReady && <div style={{ padding: '5rem 0', textAlign: 'center' }}><Spin /></div>}
			{renderReady &&
        <>
        	<div className='jumbotron'>
        		{isCreate
        			? <h1>Create Job</h1>
        			: (
        				<>
        					<h1>Edit Job for {state.jobTitle}</h1>
        					<h3>{state.companyName}</h3>
        				</>
        			)}
        		<br />
        	</div>
        	<div>
        		<Row type='flex' justify='space-between'>
        			<Col xs={24} md={15}>
        				<Form
        					form={form}
        					onFinish={handleFormSubmit}
        					onFinishFailed={CreateEditJobController.handleOnFinishFailed}
        					layout='vertical'
        					initialValues={initialValues}
        				>
        					<Row type='flex' style={{ margin: '1rem' }}>
        						<Col xs={24} md={24}>
        							<div>
        								<span style={{ color: '#6F7885' }}>You may choose to post in more than 1 language</span>
        							</div>
        							{/* Job Language */}
        							<Form.Item
        								name='jobType'
        								label={'Job Language'}
        								colon={false}
        								rules={[
        									{
        										required: true,
        										message: 'Please select at least one job language'
        									}
        								]}
        								shouldUpdate={handleShouldLanguageUpdate}
        								style={{ marginBottom: '40px' }}
        							>
        								<Checkbox.Group style={{ marginBottom: '15px' }}>
        									<Row style={{ marginBottom: '30px' }} gutter={[16,16]}>
        										<Col span={8}>
        											<Checkbox value='en'>
        												<div className='createNewJobLanguageContainer'>
        													<div className={isJobType.en ? 'createNewJobLanguageSelected' : 'createNewJobLanguage'}>
        														<img src={logoEn} id='logoEn' alt='logoEnglish' />
        														<br /><br /><br />
        														<h3>English</h3>
        													</div>
        												</div>
        											</Checkbox>
        										</Col>
        										<Col span={8}>
        											<Checkbox value='cn'>
        												<div className='createNewJobLanguageContainer'>
        													<div className={isJobType.cn ? 'createNewJobLanguageSelected' : 'createNewJobLanguage'}>
        														<img src={logoCn} id='logoCn' alt='logoChinese' />
        														<br /><br /><br />
        														<h3>Chinese</h3>
        													</div>
        												</div>
        											</Checkbox>
        										</Col>
        										<Col span={8}>
        											<Checkbox value='my'>
        												<div className='createNewJobLanguageContainer'>
        													<div className={isJobType.my ? 'createNewJobLanguageSelected' : 'createNewJobLanguage'}>
        														<img src={logoMy} id='logoMy' alt='logoMy' />
        														<br /><br /><br />
        														<h3>Malay</h3>
        													</div>
        												</div>
        											</Checkbox>
        										</Col>
        									</Row>
        								</Checkbox.Group>
        							</Form.Item>

        							{isJobTypeError && <Alert message={'Please select at least one job language'} type='error' />}
        						</Col>
        					</Row>

        					{isJobType.en === true &&
                    <>
                    	<Row type='flex'>
                    		<Col xs={24} md={24} className='createNewJobEnCn'>
                    			<Row type='flex' justify='center'>
                    				<Col span={23}>
                    					<h2><img src={logoEn} alt='logoEn' style={{ width: '2rem' }} />&nbsp;Job Details for English App</h2>
                    					<Form.Item
                    						label={'Job Title'}
                    						name='title'
                    						rules={[
                    							{
                    								required: true,
                    								message: 'Please fill in the job title',
                    								transform: (value) => value === undefined ? null : value.trim()
                    							}
                    						]}
                    					>
                    						<Input placeholder={'Sales Associate'} />
                    					</Form.Item>
                    				</Col>
                    			</Row>
                    			<Row type='flex' justify='center'>
                    				<Col span={23}>
                    					<Form.Item
                    						label={'Job Description'}
                    						name='description'
                    						rules={[
                    							{
                    								required: true,
                    								message: 'Please fill in the job description',
                    								transform: (value) => value === undefined ? null : value.trim()
                    							}
                    						]}
                    					>
                    						<TextArea
                    							placeholder={'eg. Directing customers to merchandise within the store'} autoSize={{ minRows: 6 }}
                    						/>
                    					</Form.Item>
                    				</Col>
                    			</Row>
                    			<Row type='flex' justify='center'>
                    				<Col span={23}>
                    					<Form.Item
                    						label={'Job Requirements'}
                    						name='requirements'
                    						rules={[
                    							{
                    								required: true,
                    								message: 'Please fill in the job requirements',
                    								transform: (value) => value === undefined ? null : value.trim()
                    							}
                    						]}
                    					>
                    						<TextArea
                    							placeholder={'Welcome to apply'} autoSize={{ minRows: 6 }}
                    						/>
                    					</Form.Item>
                    				</Col>
                    			</Row>
                    		</Col>
                    	</Row>
                    </>}
        					{isJobType.cn === true &&
                    <>
                    	<Row type='flex'>
                    		<Col xs={24} md={24} className='createNewJobEnCn'>
                    			<Row type='flex' justify='center'>
                    				<Col span={23}>
                    					<h2><img src={logoCn} alt='logoCn' style={{ width: '2rem' }} />&nbsp;Job Details for Chinese App</h2>
                    					<Form.Item
                    						label={'Job Title 工作名称'}
                    						name='titleCn'
                    						rules={[
                    							{
                    								required: true,
                    								message: 'Please fill in the job title',
                    								transform: (value) => value === undefined ? null : value.trim()
                    							}
                    						]}
                    					>
                    						<Input placeholder={'Sales Associate'} />
                    					</Form.Item>
                    				</Col>
                    			</Row>
                    			<Row type='flex' justify='center'>
                    				<Col span={23}>
                    					<Form.Item
                    						label={'Job Description 工作详情'}
                    						name='descriptionCn'
                    						rules={[
                    							{
                    								required: true,
                    								message: 'Please fill in the job description',
                    								transform: (value) => value === undefined ? null : value.trim()
                    							}
                    						]}
                    					>
                    						<TextArea
                    							placeholder={'eg. Directing customers to merchandise within the store'} autoSize={{ minRows: 6 }}
                    						/>
                    					</Form.Item>
                    				</Col>
                    			</Row>
                    			<Row type='flex' justify='center'>
                    				<Col span={23}>
                    					<Form.Item
                    						label={'Requirements 工作需求'}
                    						name='requirementsCn'
                    						rules={[
                    							{
                    								required: true,
                    								message: 'Please fill in the job requirements',
                    								transform: (value) => value === undefined ? null : value.trim()
                    							}
                    						]}
                    					>
                    						<TextArea
                    							placeholder={'Welcome to apply'} autoSize={{ minRows: 6 }}
                    						/>
                    					</Form.Item>
                    				</Col>
                    			</Row>
                    		</Col>
                    	</Row>
                    </>}
        					{isJobType.my === true &&
                    <>
                    	<Row type='flex'>
                    		<Col xs={24} md={24} className='createNewJobEnCn'>
                    			<Row type='flex' justify='center'>
                    				<Col span={23}>
                    					<h2><img src={logoMy} alt='logoMy' style={{ width: '2rem' }} />&nbsp;Job Details for Malay App</h2>
                    					<Form.Item
                    						label={'Job Title (Jawatan)'}
                    						name='titleMy'
                    						rules={[
                    							{
                    								required: true,
                    								message: 'Please fill in the job title',
                    								transform: (value) => value === undefined ? null : value.trim()
                    							}
                    						]}
                    					>
                    						<Input placeholder={'Sales Associate'} />
                    					</Form.Item>
                    				</Col>
                    			</Row>
                    			<Row type='flex' justify='center'>
                    				<Col span={23}>
                    					<Form.Item
                    						label={'Job Description (Deskripsi Kerja)'}
                    						name='descriptionMy'
                    						rules={[
                    							{
                    								required: true,
                    								message: 'Please fill in the job description',
                    								transform: (value) => value === undefined ? null : value.trim()
                    							}
                    						]}
                    					>
                    						<TextArea
                    							placeholder={'eg. Directing customers to merchandise within the store'} autoSize={{ minRows: 6 }}
                    						/>
                    					</Form.Item>
                    				</Col>
                    			</Row>
                    			<Row type='flex' justify='center'>
                    				<Col span={23}>
                    					<Form.Item
                    						label={'Requirements (Keperluan)'}
                    						name='requirementsMy'
                    						rules={[
                    							{
                    								required: true,
                    								message: 'Please fill in the job requirements',
                    								transform: (value) => value === undefined ? null : value.trim()
                    							}
                    						]}
                    					>
                    						<TextArea
                    							placeholder={'Welcome to apply'} autoSize={{ minRows: 6 }}
                    						/>
                    					</Form.Item>
                    				</Col>
                    			</Row>
                    		</Col>
                    	</Row>
                    </>}
        					<Row type='flex' style={{ margin: '1rem' }}>
        						<Col xs={24} md={24} id='job-specification' style={{ backgroundColor: 'white', borderRadius: '15px' }}>
        							<h3 style={{ marginBottom: '20px' }}>Job Specification</h3>
        							{(isCreate && currentUserCompanies.length)
        								? (
        									<Row type='flex' justify='center'>
        										<Col xs={24} md={24}>
        											{/* Posting job for */}
        											<div className='ant-form-item-label'>
        												<label className='ant-form-item-required ant-form-item-no-colon'>
        													{'Posting job for'}
        												</label>
        											</div>
        											{/* <div>
                            <Checkbox
                              indeterminate={checkboxIndeterminate}
                              onChange={handleCompanySelectCheckAllChange}
                              checked={checkboxCheckall}
                              disabled={!isCreate}
                            >
                              {t('check_all')}
                            </Checkbox>
                          </div> */}
        											<Form.Item
        												name='selectedCompany'
        												colon={false}
        												rules={[
        													{
        														required: true,
        														message: 'Please select the company of the job you are posting for'
        													}
        												]}
        											>
        												<Select
        													mode='multiple'
        													options={currentUserCompanies}
        													value={selectedCompanies}
        													optionFilterProp='label'
        													onChange={handleCompanySelectChange}
        													className='createUserCompanySelect'
        													disabled={!isCreate}
        												/>
        											</Form.Item>
        										</Col>
        									</Row>
        								)
        								: (
        									<Row type='flex' justify='center'>
        										<Col xs={24} md={24}>
        											<h3>{'Posting job for'}&nbsp;{state.companyName ? state.companyName : null}</h3>
        										</Col>
        									</Row>
        								)}
        							{workingLocationReady &&
                        <SelectWorkingLocation
                        	currentUserBranches={currentUserBranches}
                        	checkboxCompanies={selectedCompanies}
                        	mrtStationsList={mrtStationsList}
                        	setWorkingLocationReady={setWorkingLocationReady}
                        	handleSelect={handleSelect}
                        	cities={cities}
                        />}
        							<Row type='flex' justify='center'>
        								<Col xs={24} md={24}>
        									{checkboxBranchError && <Alert message={'Please select at least one branch and/or MRT Station as the working location for each company selected'} type='error' />}
        								</Col>
        							</Row>
        							<Row type='flex' justify='center'>
        								<Col xs={24} md={24}>
        									<>
        										<Form.Item
        											label={'Job Category'}
        											name='category'
        											rules={[
        												{
        													required: true,
        													message: 'Please select a Job Category that corresponds with the Job'
        												}
        											]}
        										>
        											<Select
        												placeholder={'Please select a Job Category'}
        												showSearch
        												filterOption={(input, option) =>
        													option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
        												onChange={(e) => handleCategoryVisibility(e)}
        												dropdownMatchSelectWidth={false}
        											>
        												{jobCategories.map(({ id, name }) => <Option value={id} key={id}>{name}</Option>)}
        											</Select>
        										</Form.Item>
        										{isOtherSelected &&
                              <Form.Item
                              	label={'If Others, Please Specify'}
                              	name='categoryText'
                              	rules={[
                              		{
                              			required: true,
                              			message: 'Please specify a Category that corresponds with the Job'
                              		}
                              	]}
                              >
                              	<Input placeholder={'Sales Associate'} />
                              </Form.Item>}
        										<Form.Item
                              	label={'Job Industry'}
                              	name='specialization'
                              	rules={[
                              		{
                              			required: true,
                              			message: 'Please select an Industry that corresponds with the Job'
                              		}
                              	]}
        										>
                              	<Select
                              		placeholder={'Please select a Job Industry'}
                              		showSearch
                              		allowClear
                              		filterOption={(input, option) =>
                              			option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                              		dropdownMatchSelectWidth={false}
                              	>
                              		{jobSpecialization.map(({ id, name }) => <Option value={id} key={id}>{name}</Option>)}
                              	</Select>
        										</Form.Item>
        									</>
        								</Col>
        							</Row>
        							<Row type='flex' justify='center'>
        								<Col xs={24} md={24}>
        									<Form.Item
        										label={'Job Post Expiry Date'}
        										name='jobPostEndDate'
        										rules={[
        											{
        												required: true,
        												message: 'Please select an expiry date'
        											}
        										]}
        									>
        										<DatePicker
        											onChange={(val) => {
        												setJobPostEndDate(val)
        											}}
        											disabled={isJobPostEndDateDisabled}
        											showToday={false}
        											disabledDate={disabledDate}
        										/>
        									</Form.Item>
        								</Col>
        							</Row>
        							<Row type='flex' justify='center'>
        								<Col xs={24} md={24}>
        									<Form.Item
        										name='employmentType'
        										label={'Employment Type'}
        										colon={false}
        										rules={[
        											{
        												required: true,
        												message: 'Please select at least one employment type'
        											}
        										]}
        									>
        										<Checkbox.Group
        											onChange={handleEmploymentType}
        											options={[
        												{ label: 'Full Time Salary', value: 'ft' },
        												{ label: 'Part Time Salary', value: 'pt' },
        												{ label: 'Contract Salary', value: 'contract' }
        											]}
        										/>
        									</Form.Item>
        									{isEmploymentTypeError && <Alert message={'Please select at least one employment type'} type='error' />}
        								</Col>
        							</Row>
        							{isEmploymentType.FT &&
                        <Row type='flex' justify='center'>
                        	<Col xs={24} md={24}>
                        		<h4>Full Time Salary</h4>
                        		<Row>
                        			<Col xs={24} md={6}>
                        				<Form.Item
                        					label={'Min Salary'}
                        					colon={false}
                        					name='minSalaryFT'
                        					rules={[
                        						{
                        							transform: (value) => (value === undefined || value === null) ? null : value.trim()
                        						}
                        					]}
                        				>
                        					<Input addonBefore={'Min'} type='number' min='0' />
                        				</Form.Item>
                        			</Col>
                        			<Col xs={24} md={6}>
                        				<Form.Item
                        					label={'Max Salary'}
                        					colon={false}
                        					name='maxSalaryFT'
                        					dependencies={['minSalaryFT']}
                        					rules={[
                        						{
                        							transform: (value) => (value === undefined || value === null) ? null : value.trim()
                        						},
                        						({ getFieldValue }) => ({
                        							validator(rule, value) {
                        								const minSalary = parseInt(getFieldValue('minSalaryFT'))
                        								if (minSalary && value) {
                        									if (minSalary <= value) return Promise.resolve()
                        									return Promise.reject('Maximum salary cannot be less than minimum salary')
                        								} else if (minSalary || value) {
                        									return Promise.resolve()
                        								} else {
                        									return Promise.reject('Please fill in the maximum or minimum salary')
                        								}
                        							}
                        						})
                        					]}
                        				>
                        					<Input addonBefore={'Max'} type='number' min='0' />
                        				</Form.Item>
                        			</Col>
                        			<Col xs={24} md={6}>
                        				<Form.Item
                        					label={'Frequency'}
                        					colon={false}
                        					name='salaryTypeFT'
                        					initialvalue='PER MONTH'
                        					rules={[
                        						{
                        							message: 'Please select the salary frequency'
                        						}
                        					]}
                        				>
                        					<Select disabled>
                        						<Option value='PER MONTH'>{'per month'}</Option>
                        					</Select>
                        				</Form.Item>
                        			</Col>
                        		</Row>
                        	</Col>
                        </Row>}
        							{isEmploymentType.PT &&
                        <Row type='flex' justify='center'>
                        	<Col xs={24} md={24}>
                        		<h4>{'Part Time Salary'}</h4>
                        		<Row>
                        			<Col xs={24} md={6}>
                        				<Form.Item
                        					label={'Min Salary'}
                        					colon={false}
                        					name='minSalaryPT'
                        					rules={[
                        						{
                        							message: 'Please fill in minimum or maximum salary',
                        							transform: (value) => (value === undefined || value === null) ? null : value.trim()
                        						}
                        					]}
                        				>
                        					<Input addonBefore={'Min'} type='number' min='0' />
                        				</Form.Item>
                        			</Col>
                        			<Col xs={24} md={6}>
                        				<Form.Item
                        					label={'Max Salary'}
                        					colon={false}
                        					name='maxSalaryPT'
                        					dependencies={['minSalaryPT']}
                        					rules={[
                        						{
                        							transform: (value) => (value === undefined || value === null) ? null : value.trim()
                        						},
                        						({ getFieldValue }) => ({
                        							validator(rule, value) {
                        								const minSalary = parseInt(getFieldValue('minSalaryPT'))
                        								if (minSalary && value) {
                        									if (minSalary <= value) return Promise.resolve()
                        									return Promise.reject('Maximum salary cannot be less than minimum salary')
                        								} else if (minSalary || value) {
                        									return Promise.resolve()
                        								} else {
                        									return Promise.reject('Please fill in the maximum or minimum salary')
                        								}
                        							}
                        						})
                        					]}
                        				>
                        					<Input addonBefore={'Max'} type='number' min='0' />
                        				</Form.Item>
                        			</Col>
                        			<Col xs={24} md={6}>
                        				<Form.Item
                        					label={'Frequency'}
                        					colon={false}
                        					name='salaryTypePT'
                        					initialvalue='PER HOUR'
                        					rules={[
                        						{
                        							required: true,
                        							message: 'Please select the salary frequency'
                        						}
                        					]}
                        				>
                        					<Select>
                        						<Option value='PER HOUR'>per hour</Option>
                        						<Option value='PER DAY'>per day</Option>
                        						<Option value='PER WEEK'>per week</Option>
                        						<Option value='PER MONTH'>per month</Option>
                        					</Select>
                        				</Form.Item>
                        			</Col>
                        		</Row>
                        	</Col>
                        </Row>}
        							{isEmploymentType.CONTRACT &&
                        <Row type='flex' justify='center'>
                        	<Col xs={24} md={24}>
                        		<h4>{'Contract Salary'}</h4>
                        		<Row>
                        			<Col xs={24} md={6}>
                        				<Form.Item
                        					label={'Min Salary'}
                        					colon={false}
                        					name='minSalaryContract'
                        					rules={[
                        						{
                        							message: 'Please fill in minimum or maximum salary',
                        							transform: (value) => (value === undefined || value === null) ? null : value.trim()
                        						}
                        					]}
                        				>
                        					<Input addonBefore={'Min'} type='number' min='0' />
                        				</Form.Item>
                        			</Col>
                        			<Col xs={24} md={6}>
                        				<Form.Item
                        					label={'Max Salary'}
                        					colon={false}
                        					name='maxSalaryContract'
                        					dependencies={['minSalaryContract']}
                        					rules={[
                        						{
                        							transform: (value) => (value === undefined || value === null) ? null : value.trim()
                        						},
                        						({ getFieldValue }) => ({
                        							validator(rule, value) {
                        								const minSalary = parseInt(getFieldValue('minSalaryContract'))
                        								if (minSalary && value) {
                        									if (minSalary <= value) return Promise.resolve()
                        									return Promise.reject('Maximum salary cannot be less than minimum salary')
                        								} else if (minSalary || value) {
                        									return Promise.resolve()
                        								} else {
                        									return Promise.reject('Please fill in the maximum or minimum salary')
                        								}
                        							}
                        						})
                        					]}
                        				>
                        					<Input addonBefore={'Max'} type='number' min='0' />
                        				</Form.Item>
                        			</Col>
                        			<Col xs={24} md={6}>
                        				<Form.Item
                        					label={'Frequency'}
                        					colon={false}
                        					name='salaryTypeContract'
                        					initialvalue='PER MONTH'
                        					rules={[
                        						{
                        							required: true,
                        							message: 'Please select the salary frequency'
                        						}
                        					]}
                        				>
                        					<Select>
                        						<Option value='PER HOUR'>per hour</Option>
                        						<Option value='PER DAY'>per day</Option>
                        						<Option value='PER WEEK'>per week</Option>
                        						<Option value='PER MONTH'>{'per month'}</Option>
                        					</Select>
                        				</Form.Item>
                        			</Col>
                        		</Row>
                        	</Col>
                        </Row>}
        							<Row type='flex' justify='center'>
        								<Col span={24}>
        									<Form.Item
        										label='Minimum education '
        										name='minimumEducation'
        										colon={false}
        										rules={
        											[{
        												required: true,
        												message: 'This is required'
        											}]
        										}
        									>
        										<Select
        											style={{ width: '100%' }}
        											placeholder='Select minimum education'
        										>
        											<Option value='No minimum education'>No minimum education</Option>
        											<Option value='Diploma'>Diploma</Option>
        											<Option value='Degree'>Degree</Option>
        											<Option value='Postgraduate'>Postgraduate</Option>
        										</Select>
        									</Form.Item>
        								</Col>
        							</Row>
        						</Col>
        					</Row>
        					<Row type='flex' style={{ padding: '1rem' }}>
        						<Col xs={24} md={24}>
        							<p style={{ fontSize: '18px', fontWeight: 'bold', paddingTop: '10px', borderTop: '2px dotted grey', marginTop: '10px' }}>Do you have any questions for the jobseekers? &nbsp; <Switch defaultChecked={haveQuestion} onChange={(val) => setHaveQuestion(val)} /></p>
        							{haveQuestion && <p style={{ fontSize: '12px' }}>Click on up/down arrow to sort question[s].</p>}
        							{haveQuestion &&
                        <div>
                        	{jobQuestion.map((jq, i) => {
                        		return (
                        			<Card key={i} style={{ marginTop: '5px' }}>
                        				<Row>
                        					<Col span={1}>
                        						<p style={{ marginTop: '5px' }}>
                        							<Tooltip title={i > 0 ? 'Click to Move Up' : ''}>
                        								<FontAwesomeIcon onClick={() => moveUpDown('up', i)} icon={faSortUp} style={{ color: i <= 0 ? 'grey' : 'black', cursor: i > 0 ? 'n-resize' : 'normal', fontSize: '16px' }} />
                        							</Tooltip><br />
                        							<Tooltip placement='bottom' title={i < jobQuestion.length - 1 ? 'Click to Move Down' : ''}>
                        								<FontAwesomeIcon onClick={() => moveUpDown('down', i)} icon={faSortDown} style={{ marginTop: '-10px', color: i >= jobQuestion.length - 1 ? 'grey' : 'black', cursor: i < jobQuestion.length - 1 ? 's-resize' : 'normal', fontSize: '16px' }} />
                        							</Tooltip>
                        						</p>
                        					</Col>
                        					<Col span={23}>
                        						<Row>
                        							<Col span={12}>
                        								<p>
                                          Question Type :
                        									<strong>
                        										{jq.questionType === 'MCQ' && ' Multiple Choice'}
                        										{jq.questionType === 'YESNO' && ' Yes / No'}
                        										{jq.questionType === 'OPENENDED' && ' Open Ended'}
                        									</strong>
                        								</p>
                        							</Col>
                        							<Col span={12} style={{ textAlign: 'right' }}>
                        								<Button onClick={() => deleteQuestion(i)} size='small' type='link' shape='circle' icon={<DeleteOutlined />} />
                        							</Col>
                        						</Row>
                        						<Row>
                        							<Col span={24}>
                        								<Input placeholder='Enter Question' value={jq.question} style={{ backgroundColor: '#FAFAFA' }} disabled={jq.isTemplate} onChange={(val) => questionChange(val, i)} required /><br /><br />
                        								{jq.questionType === 'MCQ' &&
                                          <Input type='number' placeholder='Enter the number of max answers' defaultValue={jq.maxAnswer} style={{ backgroundColor: '#FAFAFA' }} disabled={jq.isTemplate} onChange={(val) => maxAnswerChange(val, i)} required />}
                        								{jq.questionType !== 'OPENENDED' && <p style={{ marginTop: '10px' }}>Answers</p>}
                        								{(jq.Answers.length > 0 && jq.questionType === 'YESNO') && jq.Answers.map((ans, ansIndex) => {
                        									return (<Button key={ansIndex} style={{ marginRight: '5px', marginTop: '5px' }}>{ans.answer}</Button>)
                        								})}
                        								{(jq.Answers.length > 0 && jq.questionType === 'MCQ' && jq.isTemplate) && jq.Answers.map((ans, ansIndex) => {
                        									return (
                        										<div key={ansIndex}>
                        											<h5>Answer {ansIndex + 1}</h5>
                        											<p style={{ fontSize: '14px' }}>
                        												<span>{ans.answer}</span><br />
                        												<span>{ans.answerChinese}</span><br />
                        												<span>{ans.answerMalay}</span>
                        											</p>
                        										</div>
                        									)
                        								})}
                        								{(jq.Answers.length > 0 && jq.questionType === 'MCQ' && !jq.isTemplate) && jq.Answers.map((ans, ansIndex) => {
                        									return (
                        										<div key={ansIndex}>
                        											<Row>
                        												<Col span={22}>
                        													<Input type='text' value={ans.answer} placeholder='Enter your answer' style={{ backgroundColor: '#FAFAFA', margin: '5px 0px' }} onChange={(val) => answerChange(val, i, ansIndex)} required />
                        												</Col>
                        												{ansIndex > 0 && (
                        													<Col span={2} justify='right' style={{ textAlign: 'center', marginTop: '5px' }}>
                        														<Tooltip>
                        															<Button type='link' onClick={() => { removeMcqAns(i, ansIndex) }}>
                        																<FontAwesomeIcon icon={faTimes} />
                        															</Button>
                        														</Tooltip>
                        													</Col>)}
                        											</Row>
                        										</div>
                        									)
                        								})}
                        								{(jq.questionType === 'MCQ' && !jq.isTemplate) && <Button type='primary' icon={<PlusOutlined />} onClick={() => addNewAnswer(i)}>Add Answer</Button>}
                        							</Col>
                        						</Row>
                        					</Col>
                        				</Row>
                        			</Card>
                        		)
                        	})}
                        	{jobQuestion.length <= 0 && <p>No Question, add by choosing preset questions or add your own below.</p>}
                        	<br />
                        	<Row>
                        		<Col md={12} xs={24} style={{ paddingRight: '10px', marginBottom: '10px' }}>
                        			<Button onClick={handleSearchFromTemplate} block icon={<SearchOutlined />}>Choose from preset template</Button>
                        			{searchFromTemplate && <ChooseFromTemplate addNewQuestion={addNewQuestion} />}
                        		</Col>
                        		<Col md={12} xs={24}>
                        			<Dropdown overlay={(
                        				<Menu>
                        					<Menu.Item onClick={addYesNoQuestion}>
                        						<Button type='link'>Yes / No</Button>
                        					</Menu.Item>
                        					<Menu.Item onClick={addMultipleChoiceQuestion}>
                        						<Button type='link'>Multiple Choice</Button>
                        					</Menu.Item>
                        					<Menu.Item onClick={addOpenEndedQuestion}>
                        						<Button type='link'>Open Ended</Button>
                        					</Menu.Item>
                        				</Menu>
                        			)}
                        			>
                        				<Button block icon={<PlusOutlined />}>Add my own question</Button>
                        			</Dropdown>
                        		</Col>
                        	</Row>
                        </div>}
        							<br />
        						</Col>
        					</Row>
        					<Row type='flex' style={{ padding: '0 1rem'}}>
                    	<Col xs={24} md={24}>
                    		<Form.Item
                    			label='Tag Event'
                    			name='event'
                    		>
                    			<Select
                    				allowClear
                    				placeholder='Select an event'
                    				showSearch
                    				filterOption={(input, option) =>
                    					option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    				onChange={handleEventChange}
                    			>
                    				{jobEvents.map((e) => <Option value={e.id} key={e.id}>{e.name}</Option>)}
                    			</Select>
                    		</Form.Item>
                    	</Col>
        					</Row>

        					<Row type='flex' style={{ padding: '0 1rem'}}>
                    	<Col xs={24} md={24}>
                    		<Form.Item
                    			label='Hashtags'
                    			name='hashtags'
                    		>
                    			<Select showSearch allowClear mode='multiple' style={{ width: '100%' }} placeholder='Add Hashtags'>
                    				{hashtags.map((e) => <Option value={e.hashtag} key={e.hashtag}>{e.hashtag}</Option>)}
                    			</Select>
                    		</Form.Item>
                    	</Col>
        					</Row>

        					<Row type='flex' style={{ paddingLeft: '1rem' }} className='tafep-xs'>
        						<Col xs={24} md={24}>
        							<h3 style={{ fontSize: '18px', fontWeight: 'bold' }}>Your job posting should not include discrimination against the following</h3>
        							<ol>
        								<li>Nationality</li>
        								<li>Age</li>
        								<li>Gender</li>
        								<li>Race</li>
        								<li>Religion</li>
        								<li>Language</li>
        								<li>Family/Marital Status</li>
        							</ol>
        							<p>
                          For more information,
                          &nbsp;
        								<a href='https://www.tal.sg/tafep/employment-practices/recruitment/job-advertisements' target='_blank' rel='noopener noreferrer'>click here</a>
        							</p>
        						</Col>
        					</Row>

        					<Row type='flex' style={{ margin: '1rem' }}>
        						<Col xs={24} md={24} style={{ textAlign: 'right' }}>
        							<Button style={{ marginRight: '1rem' }} onClick={() => navigate(-1)}>Cancel</Button>
        							<Button type='primary' htmlType='submit'>{isCreate ? 'Create Job' : 'Update'}</Button>
        						</Col>
        					</Row>
        				</Form>
        			</Col>
        			<Col xs={24} md={8} style={{ padding: '0 1rem' }} className='tafep'>
        				<h3 style={{ fontSize: '18px', fontWeight: 'bold' }}>Your job posting should not include discrimination against the following</h3>
        				<ol>
        					<li>Nationality</li>
        					<li>Age</li>
        					<li>Gender</li>
        					<li>Race</li>
        					<li>Religion</li>
        					<li>Language</li>
        					<li>Family/Marital Status</li>
        				</ol>
        				<p>
                  For more information,
                  &nbsp;
        					<a href='https://www.tal.sg/tafep/employment-practices/recruitment/job-advertisements' target='_blank' rel='noopener noreferrer'>click here</a>
        				</p>
        			</Col>
        		</Row>
        	</div>
        	<br />
        </>}
		</>
	)
}
export default CreateEditJobView
